<template>
  <div>
    <div class="d-flex align-items-center">
      <input
        v-for="(val, key) in digitsNum"
        @paste="handlePaste"
        @keyup="($event) => handleKeyUp($event, key)"
        @focus="($event) => $event.target.select()"
        v-model="values[key]"
        :key="`${val}-${key}`"
        :autofocus="0 === key"
        maxlength="1"
        class="mx-1 text-center form-control"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from "@vue/composition-api";

export default defineComponent({
  name: "InputCode",
  emits: ["input"],
  props: {
    value: String,
  },
  setup(props, { emit }) {
    const digitsNum = 6;

    const values = ref(props.value ? props.value.split("") : []);

    const isDigitsValid = () => {
      return digitsNum === values.value.filter((item) => !!item).length;
    };

    const handlePaste = (evt) => {
      const pastedData = evt.clipboardData.getData("text");

      for (let i = 0; i < pastedData.substr(0, digitsNum).length; i++) {
        if (new RegExp("^([0-9])$").test(pastedData[i])) values.value[i] = pastedData[i];
      }

      if (isDigitsValid()) emit("input", values.value.join(""));
    };

    const handleKeyUp = (evt, index) => {
      if (evt.key === "Backspace") {
        values.value[index] = null;

        return;
      } else if (new RegExp("^([0-9])$").test(evt.key)) {
        values.value[index] = evt.key;

        if (evt.target.nextElementSibling) evt.target.nextElementSibling.focus();

        if (isDigitsValid()) emit("input", values.value.join(""));
      }
    };

    watch(
      () => props.value,
      (newValue) => {
        if (newValue) return;

        const formControls = document.querySelectorAll(".form-control");

        values.value = [];

        formControls[0].focus();
      }
    );

    return {
      digitsNum,
      values,
      handlePaste,
      handleKeyUp,
    };
  },
});
</script>

<style scoped>
.d-flex {
  margin: 0 -0.25rem;
}
</style>
